module.exports = __webpack_public_path__ + "img/logo_meu_CNA.d02f7d6c.png";